import { groups } from '@/data/institutionalBlueprint';
import { plainText, contentValue, firstImage } from './contentApi';

export const siteUrl = 'https://gassgroup.com.br';
const managed = '[data-site-meta]';
export function applyPageMeta({
  title = '',
  description = '',
  image = '',
  imageAlt = '',
  path = '/',
  type = 'website',
  noindex = false,
} = {}) {
  document.head.querySelectorAll(managed).forEach((el) => el.remove());
  document.title = plainText(title);
  const canonical = new URL(path.split('?')[0].split('#')[0], siteUrl).href;
  const add = (tag, attrs) => {
    const el = document.createElement(tag);
    el.setAttribute('data-site-meta', '');
    Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
    document.head.appendChild(el);
  };
  const meta = (key, value, property = false) => {
    if (value) add('meta', { [property ? 'property' : 'name']: key, content: value });
  };
  const cleanTitle = plainText(title),
    cleanDescription = plainText(description).slice(0, 200);
  add('link', { rel: 'canonical', href: canonical });
  meta('description', cleanDescription);
  meta('robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
  meta('og:locale', 'pt_BR', true);
  meta('og:type', type, true);
  meta('og:site_name', 'GASS GROUP', true);
  meta('og:title', cleanTitle, true);
  meta('og:description', cleanDescription, true);
  meta('og:url', canonical, true);
  meta('twitter:card', image ? 'summary_large_image' : 'summary');
  meta('twitter:title', cleanTitle);
  meta('twitter:description', cleanDescription);
  if (image) {
    const absolute = new URL(image, siteUrl).href;
    meta('og:image', absolute, true);
    if (absolute.startsWith('https:')) meta('og:image:secure_url', absolute, true);
    meta('og:image:alt', plainText(imageAlt || title), true);
    meta('twitter:image', absolute);
    meta('twitter:image:alt', plainText(imageAlt || title));
  }
}

export function metaFromRecords(records, path, type = 'website') {
  const entries = records.filter((entry) => entry.item);
  const pick = (fields) => {
    for (const { item, screen } of entries) {
      for (const field of fields) {
        if (screen.campos.some((f) => f.campo === field) && plainText(contentValue(item, field)))
          return contentValue(item, field);
      }
    }
    return '';
  };
  const hero = entries.find(({ screen }) => screen.chave.endsWith('-hero'));
  const sectionName =
    hero && hero.screen.campos.some((f) => f.campo === 'iti_referencia')
      ? plainText(contentValue(hero.item, 'iti_referencia'))
      : '';
  const recordTitle = plainText(pick(['iti_nome']));
  // Never use contact recipient/e-mail reference as SEO description.
  const description = pick(['iti_resumo1', 'iti_descricao1', 'iti_descricao2']);
  const segments = path.split('/').filter(Boolean);
  const group = groups.find((entry) => entry.chave === (segments[0] || 'home'));
  const screenName = segments.length > 1 ? recordTitle : group?.nome || sectionName;
  const normalized = (value) => plainText(value).toLocaleLowerCase('pt-BR').trim();
  const complement = [recordTitle, sectionName, description]
    .map(plainText)
    .find(
      (value) =>
        value && normalized(value) !== normalized(screenName) && normalized(value) !== 'gass group',
    );
  const title = [screenName, 'Gass Group', complement?.slice(0, 140)].filter(Boolean).join(' - ');
  const imageEntry = entries.find(({ item, screen }) => firstImage(item, screen));
  applyPageMeta({
    title,
    description: description || title,
    path,
    type,
    image: imageEntry
      ? firstImage(imageEntry.item, imageEntry.screen)
      : title
        ? '/site-assets/layouts/gass-groupv1-0110/assets/img/logo-gass-50-anos.png'
        : '',
    imageAlt: title,
  });
}
